// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"506":"9a30504c","586":"9a30504c","596":"fe4c0bc4","686":"9a30504c","702":"8e249d87"}[chunkId] + ".chunk.css";
};